export const FUNCIONES = [
  { ruta: "/programa-presupuestos-reformas", nombre: "Presupuestos", landing: true },
  { ruta: "/facturacion-verifactu-igic", nombre: "Facturación con VeriFactu" },
  { ruta: "/igic-control-trimestral", nombre: "IGIC y control trimestral" },
  { ruta: "/gestion-de-obras", nombre: "Gestión de obras" },
  { ruta: "/fichaje-trabajadores-obra", nombre: "Fichaje de trabajadores" },
  { ruta: "/certificaciones-obra-subcontratas", nombre: "Certificaciones y subcontratas" },
];

export const TODAS_FUNCIONES = { ruta: "/funciones", nombre: "Todas las funciones" };

export const ISLAS = [
  { ruta: "/software-reformas-canarias", nombre: "Canarias" },
  { ruta: "/software-reformas-gran-canaria", nombre: "Gran Canaria" },
  { ruta: "/software-reformas-tenerife", nombre: "Tenerife" },
  { ruta: "/software-reformas-lanzarote", nombre: "Lanzarote" },
  { ruta: "/software-reformas-fuerteventura", nombre: "Fuerteventura" },
  { ruta: "/software-reformas-la-palma", nombre: "La Palma" },
];

export const RECURSOS = [
  { ruta: "/precios", nombre: "Precios" },
  { ruta: "/blog", nombre: "Blog" },
  { ruta: "/preguntas-frecuentes", nombre: "Preguntas frecuentes" },
  { ruta: "/opiniones", nombre: "Opiniones" },
];

// Páginas de aterrizaje: solo se enlazan desde el pie, en la columna indicada (no salen en los menús).
export const LANDINGS = [
  { ruta: "/programa-presupuestos-reformas-canarias", nombre: "Presupuestos para reformas en Canarias", columna: "Canarias" },
  { ruta: "/facturacion-verifactu-reformas", nombre: "Facturación VeriFactu para reformas", columna: "Funciones" },
  { ruta: "/programa-albaranes-proformas-reformas", nombre: "Albaranes y proformas para reformas", columna: "Funciones" },
  { ruta: "/facturas-anticipo-obra", nombre: "Facturas de anticipo de obra", columna: "Funciones" },
];

export const RUTAS_CONTENIDO = [...FUNCIONES, ...ISLAS].filter((x) => !x.landing).map((x) => x.ruta);

// Páginas trasladadas: [antigua] → nueva. App.js redirige y prerender.mjs deja un HTML con redirección inmediata (el hosting no permite 301).
export const REDIRECCIONES = { "/software-presupuestos-reformas": "/programa-presupuestos-reformas" };

// Páginas con imagen propia para compartir en frontend/public/og/ (se generan con scripts/og_imagenes.py).
export const RUTAS_CON_IMAGEN = new Set([...FUNCIONES, ...ISLAS, ...RECURSOS, ...LANDINGS, TODAS_FUNCIONES].map((x) => x.ruta));

// Única tabla de rutas públicas: [ruta, página]. La usan App.js (carga bajo demanda) y rutas.jsx (prerender).
export const RUTAS_PUBLICAS = [
  ...RUTAS_CONTENIDO.map((r) => [r, "contenido"]),
  ...[...FUNCIONES.filter((x) => x.landing), ...LANDINGS].map((l) => [l.ruta, "landing"]),
  ["/precios", "precios"],
  ["/funciones", "funciones"],
  ["/blog", "lista"],
  ["/blog/categoria/:slug", "lista"],
  ["/blog/:slug", "articulo"],
  ["/preguntas-frecuentes", "faq"],
  ["/opiniones", "opiniones"],
];

// ¿La ruta es una página pública de la web? Como React Router: «:slug» es un tramo, barra final opcional y sin distinguir mayúsculas.
const PATRONES_PUBLICOS = ["/", ...Object.keys(REDIRECCIONES), ...RUTAS_PUBLICAS.map(([r]) => r)]
  .map((r) => new RegExp(`^${r.replace(/:\w+/g, "[^/]+")}/?$`, "i"));
export const esRutaPublica = (ruta) => PATRONES_PUBLICOS.some((p) => p.test(ruta || ""));
